import React, { useState, useEffect, useRef } from 'react';
import styles from './WhatsappRechargePlansNew.module.css';
import { Link, useLocation } from 'react-router-dom';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import AutomaticBillPayementContent from '../AutomaticBillPayementContent/AutomaticBillPayementContent';
import AutomaticBillSetUpContent from '../AutomaticBillSetUpContent/AutomaticBillSetUpContent';
import RechargeProcessingContent from '../RechargeProcessingContent/RechargeProcessingContent';
import RechargeResultContent from '../RechargeResultContent/RechargeResultContent';
import { url } from '../../Values/constants';
import axiosHandler from '../../Services/axiosHandler';
import { connect } from 'react-redux';
import { cancleRecurring, createOrder, pgiAutoLogin, recurringHistory, recurringOrders } from '../../Services/pgi';
import { useHistory } from 'react-router';
import AutoPayDetailsContent from '../AutoPayDetailsContent/AutoPayDetailsContent';
import { deviceCheck, tenPercent } from '../../Values/utils';
import { pushToGA } from '../../Services/users';
import Loading from '../../Components/Loading/Loading';
import GSTModal from '../GSTModal/GSTModal';
import { fetchOrganizationData } from '../../Services/organizations';
import FreeTrialActivatedModal from '../FreeTrials/FreeTrialActivatedModal';
import MarketingBussinessPlans from '../MarketingPanel/MarketingBussinessPlans';
import MarketingTestimonials from '../MarketingPanel/MarketingTestimonials';
import FaqLayout from '../../Components/FaqLayout/FaqLayout';
import { whatsappMarketingFaqs } from './WhatsappRechargeFaqData';
interface WhatsappRechargePlansProps {
	user?: any;
	organizationData?: any;
}

const WhatsappRechargePlans: React.FC<WhatsappRechargePlansProps> = ({ user, organizationData }) => {
	let freeTrail: any;
	const [activeFilters, setActiveFilters] = useState<string[]>(['Recharge']);
	const [historyData, setHistoryData] = useState<any>();
	const [historyAmount, setHistoryAmount] = useState<any>();
	const [historyVal, setHistoryVal] = useState<any>();
	const [historyCredit, setHistoryCredit] = useState<any>();
	const [historyUsedCredit, setHistoryUsedCredit] = useState<any>();
	const [load, setLoad] = useState(false);
	const [orderData, setOrderData] = useState<any>();
	const [autoPayDetails, setAutoPayDetails] = useState<boolean>(false);
	const [whatsappRechangePlan, setWhatsappRechangePlan] = useState([
		{
			isTopup: false,
			discountedValue: '',
			originalValue: '',
			discountPercent: '',
			validity: '',
			balance: '',
			packageId: '',
		},
	]);
	const [finalwhatsappRechangePlan, setFinalWhatsappRechangePlan] = useState([
		{
			isTopup: false,
			discountedValue: '',
			originalValue: '',
			discountPercent: '',
			validity: '',
			balance: '',
			packageId: '',
		},
	]);
	const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
	const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
	const [payModal, setPayModal] = useState<any>();
	const [gst, setGst] = useState<any>('');
	const [tranId, setTranId] = useState<any>('');
	const [recr, setRecr] = useState<any>();
	const [openRechargeProcessing, setOpenRechargeProcessing] = useState<boolean>(false);
	const [rechargeResult, setRechargeResult] = useState<boolean>(false);
	const [offerPrice, setOfferPrice] = useState();
	const [packageId, setPackageId] = useState();
	const [originalPrice, setOriginalPrice] = useState();
	const [val, setVal] = useState();
	const [discountVal, setdiscountVal] = useState();
	const [balance, setBalance] = useState();
	const [result, setResult] = useState<boolean | null>(null);
	const location = useLocation();
	const [price, setPrice] = useState<any>();
	const [orignalPrice, setOrignalPrice] = useState<any>();
	const [unit, setUnit] = useState<any>();
	const [tag, setTag] = useState<any>();
	const [id, setId] = useState<any>();
	const [planName, setplanName] = useState<any>();
	const [date, setDate] = useState<any>();
	const [validityDays, setValidityDays] = useState<any>();
	const [token, setToken] = useState<any>();
	const [topUp, setTopUp] = useState<any>();
	const [isRecurringPay, setIsRecurringPay] = useState<any>('N');
	const [openGstModal, setOpenGstModal] = useState<boolean>(false);
	const [validTill, setValidTill] = useState<any>();
	const [uotPayStatus, setUotPayStatus] = useState<any>();
	const [recurringPayStatus, setRecurringPayStatus] = useState<any>();
	const history = useHistory();
	const queryParameters = new URLSearchParams(window.location.search);
	const pageType = queryParameters.get('type');
	const serviceIds = ['13739','13780'];
	const [defaultPackage, setDefaultPackage] = useState<any>();
	const [orgPassData, setOrgPassData] = useState<any>();
	const [isPgiFlowAlreadyPunched, setIsPgiFlowAlreadyPunched] = useState('');
	const [showTrialActivatedModal, setShowTrialActivatedModal] = useState(false);
	const [resPage, setResPage] = useState<any>();
	const swiperRef = useRef<any>(null);
	const [rate, setRate] = useState<any>();

	const isTrialPage = (location.state as any)?.isTrialPage ?? false;
	const marktopScreen = (location.state as any)?.marktopScreen ?? false;

	useEffect(() => {
		if (user?.uid && user?.profile) {
			readProductList();
			pushToGA('event_tracking', 'read pro', 'read pro', 'page load', user);
		}
	}, [user]);

	useEffect(() => {
		const handleBackButton = (event: PopStateEvent) => {
			event.preventDefault();
			if (isTrialPage) {
				history.push('/marketing');
			} else if (marktopScreen) {
				history.push('/marketing');
			} else {
				history.push('/subscriptionDetails');
			}
		};

		window.addEventListener('popstate', handleBackButton);

		// Cleanup event listener
		return () => {
			window.removeEventListener('popstate', handleBackButton);
		};
	}, [history]);
	useEffect(() => {
		const currentSearch = window.location.search || location.search;
		const params = new URLSearchParams(currentSearch);
		const status = params.get('st');
		let val = params.get('val');
const whatsAppFunc = async(val:any)=>{
try {
				// Replace spaces with '+' in the `val` parameter
				val = val.replace(/ /g, '+');

				// Decrypt the `val` parameter
		const decryptTokenParams = { 
              encryptedToken: val,
              url: params,
              usedecryptPAY:true
            };
          const responseObj =  await axiosHandler.get('/auth/decryptToken', { params: decryptTokenParams });
            const decryptedData = responseObj.data.decryptData

				// Parse the decrypted string manually since the delimiter is `~`
				const parsedData = Object.fromEntries(decryptedData.split('~').map((item:any) => item.split('=')));
				console.log('parsedData', parsedData);

				// Extract individual fields
				const ustenddate = parsedData['ustenddate'];
				const uotrfnum = parsedData['uotrfnum'];
				const ustsubdate = parsedData['ustsubdate'];
				const ustspmname = parsedData['ustspmname'];
				const packageId = parsedData['packageId'];
				const originalPrice = parsedData['originalPrice'];
				const price = parsedData['price'];
				const credit = parsedData['credit'];
				const validity = parsedData['validity'];
				const type = parsedData['istoup'];
				const uotpaystatus = parsedData['uotpaystatus'];
				const recurringpaystatus = parsedData['isRecurring'];
				freeTrail = parsedData['tag'];
				const punched = parsedData['punched'];
				// console.log('freeTrail', freeTrail);
				// Set state variables
				setPrice(parseInt(price, 10) || '0');
				setPackageId(packageId || '');
				setOrignalPrice(parseInt(originalPrice, 10) || '0');
				setUnit(credit || '0');
				setplanName(ustspmname || '');
				setDate(ustsubdate || '');
				setValidTill(ustenddate || '');
				setValidityDays(validity || 0);
				setId(uotrfnum || '');
				setTopUp(type);
				setUotPayStatus(uotpaystatus);
				setRecurringPayStatus(recurringpaystatus ? recurringpaystatus : 'Y');
				setTag(freeTrail ? freeTrail : '');
				setIsPgiFlowAlreadyPunched(punched ? punched : '');
			} catch (error) {
				console.error('Error processing the decrypted data:', error);
			}
}
		if (val) {
			whatsAppFunc(val)
		}
		// Handle status
		if (status === 's') {
			setRechargeResult(true);
			setShowTrialActivatedModal(true);
			setResult(false);
		} else if (status === 'f') {
			setRechargeResult(true);
			setResult(true);
		}
	}, [location]);
	useEffect(() => {
		setFinalWhatsappRechangePlan(filterData(whatsappRechangePlan, activeFilters));
	}, [activeFilters]);
	useEffect(() => {
		const minPackage = finalwhatsappRechangePlan.reduce((prev, current) => {
			return parseFloat(prev.discountedValue || '0') <= parseFloat(current.discountedValue || '0') ? prev : current;
		});
		setDefaultPackage(minPackage);
	}, [finalwhatsappRechangePlan]);

	useEffect(() => {
		fetchOrders();
	}, [user.user_super_oid]);

	const formattedDate = new Date(date).toLocaleString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: true,
	});
	const filterData = (data: any[], activeFilters: string[]) => {
		if (activeFilters.includes('Topup') && activeFilters.includes('Recharge')) {
			// Return all data if both filters are active
			return data;
		}

		if (activeFilters.includes('Topup')) {
			// Filter data where isTopup is true
			const filteredData = data.filter((item) => item.isTopup === true);
			return filteredData;
		}

		// Otherwise, filter data where isTopup is false
		const filteredData = data.filter((item) => item.isTopup === false);
		return filteredData;
	};

	const fetchOrders = async () => {
		try {
			setLoad(true);
			const ordersList = await recurringOrders(user.user_super_oid, serviceIds);
			setOrderData(ordersList);
			setLoad(false);
		} catch (error) {
			console.error('Error fetching orders:', error);
			setLoad(false);
		}
	};
	const readProductList = async () => {
		const apiUrl = url + '/pgi/readProductList';

		const payload = {
			soid: user.user_super_oid,
		};

		try {
			const response = await axiosHandler.post(apiUrl, payload);
			const data = response.data;
			setWhatsappRechangePlan(data.data);
			setFinalWhatsappRechangePlan(filterData(data.data, activeFilters));
			setRate(data.rate)
		} catch (error: any) {
			// Handle errors
			console.error('Error fetching responses:', error.response || error);
			throw error;
		}
	};
	const fetchOrgPassDataData = async () => {
		const PassData = await fetchOrganizationData(organizationData.organization_id);
		setOrgPassData(PassData);
	};
	const onClickHandler = (originalPrice: any, offerPrice: any, packageId: any, validity: any, balance: any, isRec: any) => {
		pushToGA('event_tracking', 'read pro', 'read pro', 'Recharge click', user);
		setIsRecurringPay(isRec);
		const msgData = {
			oid: user.user_super_oid,
			offerPrice: offerPrice && offerPrice !== '0' ? offerPrice : originalPrice,
			originalPrice: originalPrice,
			packageId: packageId,
			validity: validity,
			balance: balance,
			userName: `${user.user_first_name} ${user.user_last_name}`,
			usereMail: user.user_email,
		};
		localStorage.setItem('msgData', JSON.stringify(msgData));
		pgiAutoLogin(user.user_oid, (data: any) => setToken(data));
		// setIframeCreated(true)
		document.body.classList.add('no-overflow');
	};
	const setDataHandler = (originalPrice: any, offerPrice: any, packageId: any, validity: any, balance: any, dis: any) => {
		fetchOrgPassDataData();
		setPackageId(packageId);
		setOfferPrice(offerPrice);
		setOriginalPrice(originalPrice);
		setBalance(balance);
		setVal(validity);
		setdiscountVal(dis);
		setOpenTryAutoPayModal(true);
	};
	const recurHistory = async (Id: any, amount: any, credit: any, val: any, UnitUsed: any, orderValidityUint: any) => {
		pushToGA('event_tracking', 'read pro', 'read pro', 'View History click', user);
		setHistoryAmount(amount);
		setHistoryCredit(credit);
		setHistoryVal(val + ' ' + orderValidityUint);
		let used = (UnitUsed / credit) * 100;
		setHistoryUsedCredit(used);
		const historyList = await recurringHistory(user.user_super_oid, Id, serviceIds);
		document.body.classList.add('no-overflow');
		setHistoryData(historyList);
		setTranId(Id);
		setAutoPayDetails(true);
	};
	const cancleRecurringPay = (Id: any) => {
		pushToGA('event_tracking', 'read pro', 'read pro', 'Cancel Autopay click', user);
		cancleRecurring(Id, user.user_super_oid,setLoad);
	};

	return (
		<div className={`${styles.WhatsRechPlan} ${styles.Parent}`}>
			{load === true && <Loading />}
			<div className={styles.Head}>
				<div className={styles.HeadRow1}>
					WhatsApp Marketing Plans
					{!deviceCheck() && 
					<div className={styles.HeadOffer}>
						<span className={styles.HeadOfferRed}>ZERO</span> platform Fee!
					</div>}
				</div>
				{!deviceCheck() && 
					<div className={styles.HeadRow2}>
					<div className={styles.HeadRow2Lt}>
						Bulk WhatsApp messages <div className={styles.HeadRow2Reg}>straight from ReadPro!</div>
					</div>
					<div className={styles.HeadRow2Rt}>
						<div className={`${styles.HeadBenefit} ${styles.HeadBenefit1}`}>
							<span className={styles.SemiBold}>Blue tick whatsapp</span> account* <div className={styles.HeadBenefitSm}>Subjected to meta approval</div>
						</div>
						<div className={`${styles.HeadBenefit} ${styles.HeadBenefit2}`}>
							<span className={styles.SemiBold}>Faster</span> Buyer Response
						</div>
						<div className={`${styles.HeadBenefit} ${styles.HeadBenefit3}`}>
							<span className={styles.SemiBold}>100%</span> Data Security <div className={styles.HeadBenefitSm}>No Third-Party Sharing</div>
						</div>
					</div>
				</div>
				}
			</div>
			{pageType !== 'recharge-plans' &&
				orderData?.map(
					(data: any) =>
						data.success === true && (
							<div className={styles.AutoPaydetails} key={data.transactionId}>
								<div className={styles.AutoPaydetailsInner}>
									<div className={styles.AutoPaydetailTitle}>Autopay Details</div>
									<div className={styles.AtmbilpayBillCard}>
										<div className={styles.PlanCardInfo}>
											<div className={styles.PlanCardInfoi}>
												<div className={styles.PlanCardLabel}>Plan</div>
												<div className={styles.PlanCardData}>{data.recurringPackageAmount}</div>
											</div>
											<div className={styles.PlanCardInfoi}>
												<div className={styles.PlanCardLabel}>Validity</div>
												<div className={styles.PlanCardData}>{data.orderValidity + '' + ' ' + data.orderValidityUint}</div>
											</div>
											<div className={styles.PlanCardInfoi}>
												<div className={styles.PlanCardLabel}>Credits</div>
												<div className={styles.PlanCardData}>{data.recurringPackageCredits}</div>
											</div>
											<div className={styles.PlanCardInfoi}>
												<div className={styles.PlanCardLabel}>Remaining balance (Current Package)</div>
												<div className={`${styles.PlanCardData} ${styles.PlanCardDataRb}`}>{data.packageCredit - data.totalUnitUsed}</div>
											</div>
										</div>
										<div className={styles.TermsWrap}>
											<div className={styles.Terms}>
												{/* Your current package consumption stands at {((data.totalUnitUsed / data.packageCredit) * 100).toFixed(2)}%. The next payment will be triggered when remaining credits are less than {tenPercent(data.packageCredit)}. */}
												Your current package consumption stands at {((data.totalUnitUsed / data.packageCredit) * 100).toFixed(2)}%. The next payment will be triggered when remaining credits are less than 5000.
											</div>
											<div className={styles.AtmbilpayActns}>
												{!deviceCheck() && (
													<span
														className={`${styles.AtmbilpayCtaFilled} CtaFilled`}
														onClick={() =>
															recurHistory(data.transactionId, data.recurringPackageAmount, data.recurringPackageCredits, data.orderValidity, data.totalUnitUsed, data.orderValidityUint)
														}
													>
														View History
													</span>
												)}
												<span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`} onClick={() => cancleRecurringPay(data.transactionId)}>
													Cancel Autopay
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
				)}
			{!deviceCheck() && (
				<div className={styles.RechPlanLayout}>
					<div className={styles.SecTitle}>
						Choose your plan
						<Link to={'/rechargeTransactionHistory'} className={styles.RechHistCta}>
							Recharge History
						</Link>
					</div>
					<MarketingBussinessPlans />
					<MarketingTestimonials />
					<FaqLayout deviceCheck={true} data={whatsappMarketingFaqs} isNote={true} rate={rate}/>
					{openGstModal && (
						<CenteredPopUp
							setModal={setOpenGstModal}
							children={<GSTModal setGst={setGst} PayModal={() => onClickHandler(originalPrice, offerPrice, packageId, val, balance, recr)} />}
							modiferClass={styles.gstPopup}
							closeIcon={true}
						/>
					)}
					{openTryAutoPayModal && (
						<CenteredPopUp
							setModal={setOpenTryAutoPayModal}
							children={
								<AutomaticBillPayementContent
									setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
									PayModal={setOpenGstModal}
									setRecr={setRecr}
									originalPrice={originalPrice}
									offerPrice={offerPrice}
									packageId={packageId}
									setOpenTryAutoPayModal={setOpenTryAutoPayModal}
								/>
							}
							modiferClass={styles.Tabp}
							closeIcon={true}
						/>
					)}
					{openSetUpAutoPayModal && (
						<CenteredPopUp
							setModal={setOpenSetUpAutoPayModal}
							children={
								<AutomaticBillSetUpContent
									setOpenSetUpAutoPayModal={setOpenSetUpAutoPayModal}
									setOpenRechargeProcessing={setOpenGstModal}
									originalPrice={originalPrice}
									offerPrice={offerPrice}
									packageId={packageId}
									balance={balance}
									val={val}
									discountVal={discountVal}
									organizationData={orgPassData}
								/>
							}
							modiferClass={styles.Tabp}
							closeIcon={true}
						/>
					)}
					{openRechargeProcessing && (
						<CenteredPopUp
							setModal={setOpenRechargeProcessing}
							children={<RechargeProcessingContent setOpenRechargeProcessing={setOpenRechargeProcessing} setRechargeResult={setRechargeResult} />}
							modiferClass={styles.Tabp}
							closeIcon={false}
						/>
					)}
					{/* {rechargeResult && (recurringPayStatus !== 'Y' || (resPage && (resPage.marketingTab === false || !resPage.marketingTab))) && ( */}
					{rechargeResult && (
						<CenteredPopUp
							setModal={setRechargeResult}
							children={
								<RechargeResultContent
									setRechargeResult={setRechargeResult}
									result={result}
									price={price}
									unit={unit}
									Id={id}
									validityDays={validityDays}
									name={`${user.user_first_name} ${user.user_last_name}`}
									date={formattedDate}
									orignalPrice={orignalPrice}
									validTill={validTill}
									planName={planName}
									packageId={packageId}
									topUp={topUp}
									uotPayStatus={uotPayStatus}
									recurringPayStatus={recurringPayStatus}
									tag={tag}
									isPgiFlowAlreadyPunched={isPgiFlowAlreadyPunched}
									// responseGst={responseGst}
								/>
							}
							modiferClass={styles.Tabp}
							closeIcon={false}
						/>
					)}
					{/* {showTrialActivatedModal && resPage && resPage.marketingTab === true && (
						<CenteredPopUp
							setModal={setShowTrialActivatedModal}
							children={
								<FreeTrialActivatedModal
									setShowTrialActivatedModal={setShowTrialActivatedModal}
									result={result}
									price={price}
									unit={unit}
									Id={id}
									validityDays={validityDays}
									name={`${user.user_first_name} ${user.user_last_name}`}
									date={formattedDate}
									orignalPrice={orignalPrice}
									validTill={validTill}
									planName={planName}
									packageId={packageId}
									topUp={topUp}
									uotPayStatus={uotPayStatus}
									recurringPayStatus={recurringPayStatus}
									tag={tag}
								/>
							}
							modiferClass={styles.ftaModal}
							closeIcon={false}
							closeClassMofifier={styles.ftaClose}
						/>
					)} */}
					{autoPayDetails && (
						<CenteredPopUp
							setModal={setAutoPayDetails}
							children={
								<AutoPayDetailsContent
									setAutoPayDetails={setAutoPayDetails}
									historyData={historyData}
									historyAmount={historyAmount}
									historyCredit={historyCredit}
									historyVal={historyVal}
									historyUsedCredit={historyUsedCredit}
									tranId={tranId}
								/>
							}
							modiferClass={styles.Tabp}
							closeIcon={false}
						/>
					)}
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	return {
		user: state.user.data,
		organizationData: state.organization.organizationData,
	};
};

export default connect(mapStateToProps)(WhatsappRechargePlans);
